import * as actions from "../actions/actionTypes";

const initialState = {
  fileData: {
    sampleURL: null,
    selectedFile: null,
    process: {
      uploadStatus: null,
      verifyStatus: null,
      uploadRes: null,
      verifyRes: null,
    },
  },
  studentsData: {
    students: [],
    selectedStudent: null,
  },
};

export const rosteringReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.VALIDATE_ROSTER_DATA_SUCCESS:
      return {
        ...state,
        fileData: {
          ...state.fileData,
          process: {
            ...state.fileData.process,
            uploadStatus: null,
            uploadRes: null,
            verifyStatus: true,
            verifyRes: action.payload,
          },
        },
      };
    case actions.UPLOAD_ROSTER_DATA_SUCCESS:
      return {
        ...state,
        fileData: {
          ...state.fileData,
          process: {
            ...state.fileData.process,
            uploadStatus: true,
            uploadRes: action.payload,
          },
        },
      };
    case actions.GET_TEACHER_ROSTER_DETAILS_SUCCESS:
      return {
        ...state,
        studentsData: {
          ...state.studentsData,
          students: action.payload,
        },
      };
    case actions.DELETE_ROSTERED_STUDENT_SUCCESS:
      return {
        ...state,
        studentsData: {
          ...state.studentsData,
          students: Array.isArray(state?.studentsData?.students)
            ? state.studentsData.students.filter(
                (student) => student?.user_puid !== action.payload?.userPuid
              )
            : [],
        },
      };
    default:
      return state;
  }
};
